import { get, post } from './IApi';

import small_slider1 from '../images/slider-small-1.jpg';
import small_slider2 from '../images/slider-small-2.jpg';
import small_slider3 from '../images/slider-small-3.jpg';
import small_slider4 from '../images/slider-small-4.jpg';
import small_slider5 from '../images/slider-small-5.jpg';
import small_slider6 from '../images/slider-small-6.jpg';

import big_slider1 from '../images/slider1.jpg';
import big_slider2 from '../images/slider2.jpg';
import big_slider3 from '../images/slider3.jpg';

import custom_ribbon from '../images/Ribbon.svg';
import custom_holiday from '../images/Holiday.svg';
import custom_full from '../images/Fully Custom.svg';

export const LandingPageHit = async qsVarsData => {
    return await post(qsVarsData, 'generalUtils/landingPageHit');
},
    GetTitleAndMetaTags = async pageName => {
        const response = await get(`generalUtils/titleAndMetaTags/${pageName}`);
        return response.TitleAndMetaTags;
    },
    GetPhysicalCardTypes = async () => {
        const response = await get('purchaseGeneral/physicalCardTypes');
        return response.Succeeded ? response.List : [];
    },
    GetCustomPhysicalCardTypes = async () => {
        const response = await get('purchaseGeneral/customPhysicalCardTypes');
        return response.Succeeded ? response.List : [];
    },
    GetCustomPhysicalCards = async () => {
        const response = await get('shoppingcart/customPhysicalCards');
        return response.Succeeded ? response.List : [];
    },
    GetDigitalCardOccasions = async hiddenOccasionId => {
        let url = 'purchaseGeneral/digitalCardOccasions';
        if (hiddenOccasionId) {
            url += `/${hiddenOccasionId}`;
        }
        const response = await get(url);
        return response.Succeeded ? response.List : [];
    },
    GetDigitalCardSchemes = async () => {
        const response = await get('purchaseGeneral/digitalCardSchemes');
        return response.Succeeded ? response.List : [];
    },
    GetDigitalCardsForOccasion = async (occasionId, hiddenOccasionId) => {
        let url = `purchaseGeneral/digitalCards/${occasionId.toString()}`;

        if (
            hiddenOccasionId &&
            parseInt(hiddenOccasionId, 10) === parseInt(occasionId, 10)
        ) {
            url += '/true';
        }
        const response = await get(url);
        return response.Succeeded ? response.List : [];
    },
    GetSingleDigitalCardOccasion = async occasionId => {
        const response = await get(
            `purchaseGeneral/digitalCardOccasion/${occasionId.toString()}`
        );
        return response.Succeeded ? response.OccasionInfo : {};
    },
    GetSingleDigitalCardAndOccasion = async cardId => {
        const response = await get(
            `purchaseGeneral/digitalCard/${cardId.toString()}`
        );
        return response.Succeeded
            ? { OccasionInfo: response.OccasionInfo, CardInfo: response.CardInfo }
            : {};
    },
    GetShippingTypes = async () => {
        const response = await get('purchaseGeneral/shippingTypes');
        return response.Succeeded ? response.List : [];
    },
    ShowFreeHolidayShipping = async pageName => {
        const d = new Date();
        if (d.getMonth() < 11) {
            return false;
        }
        else {
            const response = await get('generalUtils/freeHolidayShipping');
            return response.Succeeded && response.ShowFreeHolidayShipping;
        }
    },
    GetCustomCardsShippingTypes = async () => {
        const response = await get('purchaseGeneral/shippingTypes/true');
        return response.Succeeded ? response.List : [];
    },
    GetPrintLayouts = async () => {
        const response = await get('purchaseGeneral/printLayouts');
        return response.Succeeded ? response.List : [];
    },
    GetTotalDonated = async () => {
        const response = await get('purchaseGeneral/total-donated');
        return response.Succeeded ? response.List : [];
    },
    GetShoppingCartItem = async donationIndex => {
        return await get(`shoppingcart/item/${donationIndex.toString()}`);
    },
    GetGiftCardRetailers = async (onlyAcceptsEcode = true) => {
        const response = await get(
            `purchaseGeneral/giftCardMerchants/${(!!onlyAcceptsEcode).toString()}`
        );
        return response.Succeeded ? response.List : [];
    },
    GetCharityList = async (listName, categoryId) => {
        let url = 'charity/list/' + (listName || 'all');
        if (categoryId) {
            url += '/' + categoryId.toString();
        }
        const response = await get(url);
        return response.Succeeded ? response.List : [];
    },
    GetCharityInfo = async charityIdOrName => {
        const response = await get(`charity/${charityIdOrName}`);
        return response.Succeeded ? response.CharityInfo : {};
    },
    GetMultipleCharityInfos = async charityIds => {
        const response = await get(`charity/filter/${charityIds.toString()}`);
        return response.Succeeded ? response.List : [];
    },
    SearchCharities = async searchTerm => {
        const response = await get(`charity/search/${searchTerm}`);
        return response.Succeeded ? response.List : [];
    },
    GetCharityCategories = async () => {
        const response = await get('charity/cats/list');
        return response.Succeeded ? response.List : [];
    },
    GetCharityCategoryCodes = async () => {
        const response = await get('charity/cats/list/code');
        return response.Succeeded ? response.List : [];
    },
    GetRedemptionCodeOrders = async () => {
        const response = await get('shoppingcart/redemptionCodePurchases');
        return response.Succeeded ? response.List : [];
    },
    GetDirectToCharityDonations = async () => {
        const response = await get('shoppingcart/directToCharityDonations');
        return response.Succeeded ? response.List : [];
    },
    GetUserPreviousRecipients = async () => {
        const response = await get('account/recipientList');
        return response.Succeeded ? response.List : [];
    },
    /**
     * Account Api
     */
    GetLoggedInUserApi = async () => {
        return await get('account/loggedInUser');
    },
    LoginUserApi = async login => {
        return await post(login, 'account/login');
    },
    LogoutUserApi = async () => {
        return await get('account/logout');
    },
    CreateAccountApi = async info => {
        return await post(info, 'account/create');
    },
    ForgotPasswordApi = async email => {
        return await get(`account/forgotPassword/${email}`);
    },
    CheckEmailAvailApi = async email => {
        const response = await get(`account/emailAvail/${email}`);
        return response.Succeeded && response.Available;
    },
    GetCustomCharityListsApi = async () => {
        return await get('account/customCharityLists');
    },
    GetCustomCharityListsByIDApi = async id => {
        return await get(`account/customCharityLists/${id}`);
    },
    CreateCustomCharityListApi = async data => {
        return await post(data, 'account/customCharityList');
    },
    SaveDefaultShippingInfoApi = async data => {
        return await post(data, 'account/defaultShippingInfo');
    },
    /**
     * Shopping Cart Api
     */
    GetCartApi = async () => {
        return await get('shoppingcart');
    },
    GetPhysicalCardsApi = async () => {
        return await get('shoppingcart/physicalCards');
    },
    GetCustomPhysicalCardsApi = async () => {
        return await get('shoppingcart/customPhysicalCards');
    },
    GetDirectToCharityDonationsApi = async () => {
        return await get('shoppingcart/directToCharityDonations');
    },
    AddPhysicalCardsApi = async data => {
        return await post(data, 'shoppingcart/physicalCards');
    },
    AddCustomPhysicalCardsApi = async data => {
        return await post(data, 'shoppingcart/customPhysicalCards');
    },
    AddCustomPhysicalCardApi = async data => {
        return await post(data, 'shoppingcart/addCustomPhysicalCard');
    },
    AddDirectToCharityDonationsApi = async data => {
        return await post(data, 'shoppingcart/directToCharityDonations');
    },
    UpdateCustomPhysicalCardApi = async (data, donationIndex) => {
        return await post(
            data,
            `shoppingcart/addCustomPhysicalCard/${donationIndex}`
        );
    },
    RemoveFromCartApi = async index => {
        return await get('shoppingcart/remove/' + index.toString());
    },
    UpdateCartTipApi = async amount => {
        return await post(amount || '0', 'shoppingcart/tip');
    },
    UpdateCardShippingInfoApi = async data => {
        return await post(
            data.shippingInfo,
            `shoppingcart/shippingInfo/${data.index}`
        );
    },
    SetPreSelectedCharityIdApi = async charityId => {
        return await post(null, `shoppingcart/preSelectedCharity/${charityId}`);
    },
    /**
     * Purchase Api
     */
    GetPhysicalCardTypesApi = async () => {
        return await get('purchaseGeneral/physicalCardTypes');
    },
    GetCustomPhysicalCardTypesApi = async () => {
        return await get('purchaseGeneral/customPhysicalCardTypes');
    },
    GetPhysicalShippingTypesApi = async () => {
        return await get('purchaseGeneral/shippingTypes');
    },
    GetCustomShippingTypesApi = async () => {
        return await get('purchaseGeneral/shippingTypes/true');
    },
    GetDigitalCardOccasionsApi = async hiddenOccasionId => {
        let url = 'purchaseGeneral/digitalCardOccasions';
        if (hiddenOccasionId) {
            url += `/${hiddenOccasionId}`;
        }
        return await get(url);
    },
    GetDigitalCardSchemesApi = async () => {
        return await get('purchaseGeneral/digitalCardSchemes');
    },
    GetPrintLayoutsApi = async () => {
        return await get('purchaseGeneral/printLayouts');
    },
    GetGiftCardRetailersApi = async (onlyAcceptsEcode = true) => {
        return await get(
            `purchaseGeneral/giftCardMerchants/${(!!onlyAcceptsEcode).toString()}`
        );
    },
    /**
     * Checkout Api
     */
    PreCheckoutApi = async data => {
        return await post(data, 'checkout/preCheckout');
    },
    CheckoutCorporateCheckApi = async data => {
        return await post(data, 'checkout/CheckoutCorporateCheck');
    },
    CheckoutCreditCardApi = async data => {
        return await post(data, 'checkout/CheckoutCreditCard');
    },
    PayPalExpressTokenApi = async (token, payerId) => {
        return await get(`checkout/PayPalExpress/${token}/${payerId}`);
    },
    CheckoutPayPalExpressApi = async () => {
        return await post(null, 'checkout/CheckoutPayPalExpress');
    },
    /**
     * Paid Orders Api
     */
    ConfirmationEmailApi = async purchaseId => {
        return await get(`/paidOrder/confirmationEmail/${purchaseId}`);
    },
    RedemptionGuaranteeApi = async data => {
        return await post(data, `/paidOrder/redemptionGuarantee`);
    },
    GetRedemptionCodeCSVApi = async purchaseId => {
        return await get(`/paidOrder/redemptionCodesCsv/${purchaseId}`);
    },
    /**
     * Contact Api
     */
    ContactApi = async data => {
        return await post(data, 'contact');
    },
    /**
     * Register Local Charity Api
     */
    RegisterLocalCharityApi = async data => {
        return await post(data, 'charity/localCharityRegister');
    },
    GetCharityCategoryCodesApi = async () => {
        return await get('charity/cats/list/code');
    },
    GetCharityCategoriesApi = async () => {
        return await get('charity/cats/list');
    },
    GetMainCharitiesApi = async () => {
        return await get('charity/list/main');
    },
    GetLocalCharitiesApi = async () => {
        return await get('charity/list/local');
    },
    GetDateCharityLastModified = async () => {
        return await get('/charity/list/dateLastModified');
    },
    // GetCharityList = async (listName, categoryId) => {
    //   let url = 'charity/list/' + (listName || 'all');
    //   if (categoryId) {
    //     url += '/' + categoryId.toString();
    //   }
    //   const response = await get(url);
    //   return response.Succeeded ? response.List : [];
    // },
    // GetMultipleCharityInfos = async charityIds => {
    //   const response = await get(`charity/filter/${charityIds.toString()}`);
    //   return response.Succeeded ? response.List : [];
    // },
    // SearchCharities = async searchTerm => {
    //   const response = await get(`charity/search/${searchTerm}`);
    //   return response.Succeeded ? response.List : [];
    // },

    DefaultDigitalCard = {
        CardId: 158,
        CardName: 'Charity Choice Card-  Flat',
        CustomHtml: '',
        HasTwoSidedPrint: 'True',
        OccasionId: 23,
        OccasionName: 'CharityChoice Gift Card',
    },
    DefaultDigitalCardOccasion = {
        OccasionId: 23,
        OccasionName: 'CharityChoice Gift Card',
        IsCustomImage: false,
        IsPopular: false,
    },
    DefaultDigitalCardLayout = {
        ColorSchemes: [
            {
                SchemeName: 'Elegant_Gray',
                SchemeText: 'Elegant Gray',
                BackgroundColor: '73726D',
            },
            { SchemeName: 'Gold', SchemeText: 'Gold', BackgroundColor: 'FFD356' },
            { SchemeName: 'Green', SchemeText: 'Green', BackgroundColor: '007515' },
            {
                SchemeName: 'Holiday_Red',
                SchemeText: 'Holiday Red',
                BackgroundColor: 'C0180D',
            },
            {
                SchemeName: 'Soft_White',
                SchemeText: 'Soft White',
                BackgroundColor: 'fafafa',
            },
            {
                SchemeName: 'Torquoise',
                SchemeText: 'Torquoise',
                BackgroundColor: '509BB8',
            },
        ],
        Description: 'One Sided - Full Page',
        IsTwoSided: false,
        LayoutId: 0,
    },
    DefaultDigitalCardScheme = {
        SchemeName: 'Soft_White',
        SchemeText: 'Soft White',
        BackgroundColor: 'fafafa',
    },
    DeliveryMethods = Object.freeze({
        Email: 1,
        Text: 2,
        Social: 3,
        Print: 4,
    }),
    AccountTypes = Object.freeze({
        Personal: 0,
        Corporate: 1,
        Charity: 2,
        Redemption: 8,
        Reward: 10
    }),
    CardTypes = Object.freeze({
        Digital: 1,
        Print: 2,
        Honor: 3,
    }),
    ShoppingCartItemTypes = Object.freeze({
        PhysicalCard: 0,
        DigitalCharityCards: 1,
        PrintableDonationCards: 2,
        RedemptionCodePurchase: 3,
        DirectToCharityDonation: 4,
        AmericanExpressBrandedRewardCards: 5,
        VisaPrepaidCard: 6,
        CustomPhysicalCard: 7,
        HonorCardToEmail: 8,
        HonorCardToPrint: 9,
        FacebookCard: 10,
        GiftCardExchange: 11,
        APICardActivation: 12,
        ManualActivation: 13,
        ExternalCodePurchase: 14,
        Unknown: 15,
    }),
    EditUrls = Object.freeze({
        [ ShoppingCartItemTypes.PhysicalCard ]: item =>
            item.ShipsToRecipient
                ? `/Purchase/PhysicalCards/ShipToRecipient/AddRecipientCards.aspx?DI=${item.ItemIndex}`
                : `/Purchase/PhysicalCards/ShipToDonor.aspx?SG=1&DI=${item.ItemIndex}`,
        [ShoppingCartItemTypes.DigitalCharityCards]: item =>
            item.IsBulkHiddenAmount
                ? `/Purchase/eCards/?ICH=1&DI=${item.ItemIndex}`
                : `/Purchase/eCards/?DI=${item.ItemIndex}`,
        [ ShoppingCartItemTypes.PrintableDonationCards ]: item =>
            `/Purchase/PrintCards/?DI=${item.ItemIndex}`,
        [ShoppingCartItemTypes.RedemptionCodePurchase]: item =>
            item.IsBulkHiddenAmount
                ? `/Purchase/RedemptionCodes/?ICH=1&DI=${item.ItemIndex}`
                : `/Purchase/RedemptionCodes/?DI=${item.ItemIndex}`,
        [ ShoppingCartItemTypes.DirectToCharityDonation ]: item =>
            `/Purchase/DirectToCharityDonation/?DI=${item.ItemIndex}`,
        [ ShoppingCartItemTypes.AmericanExpressBrandedRewardCards ]: null,
        [ ShoppingCartItemTypes.VisaPrepaidCard ]: null,
        [ ShoppingCartItemTypes.CustomPhysicalCard ]: item =>
            `/Purchase/CustomPhysicalCards/?SG=1&DI=${item.ItemIndex}`,
        [ ShoppingCartItemTypes.HonorCardToEmail ]: item =>
            `/Purchase/HonorCards/?DI=${item.ItemIndex}`,
        [ ShoppingCartItemTypes.HonorCardToPrint ]: item =>
            `/Purchase/HonorCards/?DI=${item.ItemIndex}`,
        [ ShoppingCartItemTypes.FacebookCard ]: null,
        [ ShoppingCartItemTypes.GiftCardExchange ]: null,
        [ ShoppingCartItemTypes.APICardActivation ]: null,
        [ ShoppingCartItemTypes.ManualActivation ]: null,
        [ ShoppingCartItemTypes.ExternalCodePurchase ]: null,
        [ ShoppingCartItemTypes.Unknown ]: null,
    }),
    ImageUrls = Object.freeze({
        [ ShoppingCartItemTypes.PhysicalCard ]:
            "/images/PhysicalCardsSmall.jpg?height=50",
        [ ShoppingCartItemTypes.DigitalCharityCards ]: "/images/ecards.gif",
        [ ShoppingCartItemTypes.PrintableDonationCards ]:
            "/images/CustomizedCertificatesSmall.jpg?height=50",
        [ ShoppingCartItemTypes.RedemptionCodePurchase ]: "/images/icon.jpg",
        [ ShoppingCartItemTypes.DirectToCharityDonation ]:
            "/images/DirectToCharityDonation.png",
        [ ShoppingCartItemTypes.AmericanExpressBrandedRewardCards ]: null,
        [ ShoppingCartItemTypes.VisaPrepaidCard ]: null,
        [ ShoppingCartItemTypes.CustomPhysicalCard ]:
            "/images/CustomPhysicalCards/Ribbon.png",
        [ ShoppingCartItemTypes.HonorCardToEmail ]: "/images/ecards.gif",
        [ ShoppingCartItemTypes.HonorCardToPrint ]: "/images/ecards.gif",
        [ ShoppingCartItemTypes.FacebookCard ]: null,
        [ ShoppingCartItemTypes.GiftCardExchange ]: "/images/DonateRetailCard.png",
        [ ShoppingCartItemTypes.APICardActivation ]: null,
        [ ShoppingCartItemTypes.ManualActivation ]: null,
        [ ShoppingCartItemTypes.ExternalCodePurchase ]: null,
        [ ShoppingCartItemTypes.Unknown ]: null,
    }),
    ShippingFormTypes = Object.freeze({
        All: 0,
        Physical: 1,
        Custom: 2,
        ToRecipient: 3,
    }),
    PhysicalCardTypes = Object.freeze({
        ToMe: 1,
        ToRecipient: 2,
        Custom: 3,
    }),
    DonateRetailCardsMethods = Object.freeze({
        MailIn: 1,
        Online: 2,
    }),
    CharityListTypes = Object.freeze({
        Default: 1,
        Animals: 2,
        CharityChoice: 3,
        Custom: 4,
    }),
    PaymentTypes = Object.freeze({
        Paypal: 1,
        CreditCard: 2,
        Corporate: 3,
    }),
    StatesList = [
        { value: 'AL', label: 'Alabama' },
        { value: 'AK', label: 'Alaska' },
        { value: 'AB', label: 'Alberta' },
        { value: 'AS', label: 'American Samoa' },
        { value: 'AZ', label: 'Arizona' },
        { value: 'AR', label: 'Arkansas' },
        { value: 'AA', label: 'Armed Forces Americas' },
        { value: 'AE', label: 'Armed Forces Canada/Europe/Middle East/Africa' },
        { value: 'AP', label: 'Armed Forces Pacific' },
        { value: 'BC', label: 'British Columbia' },
        { value: 'CA', label: 'California' },
        { value: 'CO', label: 'Colorado' },
        { value: 'CT', label: 'Connecticut' },
        { value: 'DE', label: 'Delaware' },
        { value: 'DC', label: 'District of Columbia' },
        { value: 'FL', label: 'Florida' },
        { value: 'GA', label: 'Georgia' },
        { value: 'GU', label: 'Guam' },
        { value: 'HI', label: 'Hawaii' },
        { value: 'ID', label: 'Idaho' },
        { value: 'IL', label: 'Illinois' },
        { value: 'IN', label: 'Indiana' },
        { value: 'IA', label: 'Iowa' },
        { value: 'KS', label: 'Kansas' },
        { value: 'KY', label: 'Kentucky' },
        { value: 'LA', label: 'Louisiana' },
        { value: 'ME', label: 'Maine' },
        { value: 'MB', label: 'Manitoba' },
        { value: 'MH', label: 'Marshall Islands' },
        { value: 'MD', label: 'Maryland' },
        { value: 'MA', label: 'Massachusetts' },
        { value: 'MI', label: 'Michigan' },
        { value: 'FM', label: 'Micronesia' },
        { value: 'MN', label: 'Minnesota' },
        { value: 'UM', label: 'Minor Outlying Islands' },
        { value: 'MS', label: 'Mississippi' },
        { value: 'MO', label: 'Missouri' },
        { value: 'MT', label: 'Montana' },
        { value: 'NE', label: 'Nebraska' },
        { value: 'NV', label: 'Nevada' },
        { value: 'NB', label: 'New Brunswick' },
        { value: 'NH', label: 'New Hampshire' },
        { value: 'NJ', label: 'New Jersey' },
        { value: 'NM', label: 'New Mexico' },
        { value: 'NY', label: 'New York' },
        { value: 'NL', label: 'Newfoundland and Labrador' },
        { value: 'NC', label: 'North Carolina' },
        { value: 'ND', label: 'North Dakota' },
        { value: 'MP', label: 'Northern Mariana Islands' },
        { value: 'NT', label: 'Northwest Territories' },
        { value: 'NS', label: 'Nova Scotia' },
        { value: 'NU', label: 'Nunavut' },
        { value: 'OH', label: 'Ohio' },
        { value: 'OK', label: 'Oklahoma' },
        { value: 'ON', label: 'Ontario' },
        { value: 'OR', label: 'Oregon' },
        { value: 'PW', label: 'Palau' },
        { value: 'PA', label: 'Pennsylvania' },
        { value: 'PE', label: 'Prince Edward Island' },
        { value: 'PR', label: 'Puerto Rico' },
        { value: 'QC', label: 'Quebec' },
        { value: 'RI', label: 'Rhode Island' },
        { value: 'SK', label: 'Saskatchewan' },
        { value: 'SC', label: 'South Carolina' },
        { value: 'SD', label: 'South Dakota' },
        { value: 'TN', label: 'Tennessee' },
        { value: 'TX', label: 'Texas' },
        { value: 'UT', label: 'Utah' },
        { value: 'VT', label: 'Vermont' },
        { value: 'VI', label: 'Virgin Islands' },
        { value: 'VA', label: 'Virginia' },
        { value: 'WA', label: 'Washington' },
        { value: 'WV', label: 'West Virginia' },
        { value: 'WI', label: 'Wisconsin' },
        { value: 'WY', label: 'Wyoming' },
        { value: 'YT', label: 'Yukon' },
    ],
    LayoutList = [
        { value: 'CardSize', label: 'One Sided - Card Size' },
        { value: 'FullPage', label: 'One sided - Full Page' },
    ],
    DeliveryMethodList = [
        { value: DeliveryMethods.Email, label: 'Email' },
        { value: DeliveryMethods.Text, label: 'Text Message' },
        { value: DeliveryMethods.Social, label: 'Share via messaging' },
        { value: DeliveryMethods.Print, label: 'Print on your own' },
    ],
    AccountTypeList = [
        { value: '0', label: 'Personal Account' },
        { value: '1', label: 'Corporate and Business' },
        { value: '5', label: 'Redemption' },
    ],
    ContactTypeList = [
        { value: 0, label: 'Suggestion' },
        { value: 1, label: 'Promotional Cause Programs' },
        { value: 2, label: 'Corporate Customization' },
        { value: 3, label: 'Inquiry' },
        { value: 4, label: 'I am having a problem with this site' },
        { value: 5, label: 'Complaint' },
        { value: 6, label: 'Order Gift Cards Assistance' },
        { value: 7, label: 'Other' },
    ],
    TryingTypeList = [
        { value: 'Purchase Gift Cards', label: 'Purchase Gift Cards' },
        { value: 'Redeem A Gift Card', label: 'Redeem A Gift Card' },
        {
            value: 'Order CharityChoice-branded Gift and Reward Cards',
            label: 'Order CharityChoice-branded Gift and Reward Cards',
        },
        { value: 'Other', label: 'Other' },
    ],
    ToolTips = {
        SpecialKidsFund:
            "This website is a fundraising project of our 501c3 umbrella organization for special needs kids. We support special needs schools, camp programs, youth groups, et. and run a nationwide 'donate a wheelchair van' program, giving the vans for no charge to needy families.",
    },
    SmallSliderItems = [
        {
            src: small_slider1,
            altText: 'American Cancer Society. Worthwhile causes; help cure diseases, prevent animal abuse, protect the environment, assist disaster relief and feed the hungry.',
            caption: '',
        },
        {
            src: small_slider2,
            caption: '',
        },
        {
            src: small_slider3,
            caption: '',
        },
        {
            src: small_slider4,
            caption: '',
        },
        {
            src: small_slider5,
            caption: '',
        },
        {
            src: small_slider6,
            caption: '',
        },
    ],
    BigSliderItems = [
        {
            src: big_slider1,
            altText: 'American Cancer Society. Worthwhile causes; help cure diseases, prevent animal abuse, protect the environment, assist disaster relief and feed the hungry.',
            caption: '',
        },
        {
            src: big_slider2,
            caption: '',
        },
        {
            src: big_slider3,
            caption: '',
        },
    ],
    ImgCustomCards = {
        Ribbon: custom_ribbon,
        Holiday: custom_holiday,
        'Fully Custom': custom_full,
    },
    STEPPER_PARAMS = {
        autoHeight: true,
        noSwiping: true,
    },
    RedeemStepTitles = [
        'Step 1 - Enter your redemption code',
        'Welcome to CharityChoice redemption',
        'Step 3 - Select your charities',
        'Step 4 - Confirm before Redeem',
        'Thanks!',
    ],
    PurchasePhysicalCardStepTitles = [
        'Choose a Card Type',
        'Choose a Card Style',
        'Enter Denomination & Quantity',
    ];
